export default  {
    component: 'plant_device_report',
    name: 'plant_device_report',
    fields: [
          {
            name: 'Device',
            param: 'device',
            type: 'text',
            identifier: true,
            required: true,
          },
          {
            name: 'Parameter Config',
            param: 'parameter_config',
            type: 'json'
          },
          {
            name: 'Parameter List',
            param: 'parameter_list',
            type: 'text'
          }

  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }
